import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { FieldLines } from './FieldLines';
const chips = ['6 Volumes', '5 Bonuses', '90 ready-to-run sessions', 'Soft-ball & hard-ball tracks', 'Wet-weather swap', '60 · 75 · 90 min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Read it on your phone or print it'];

/** Players as they appear in the product diagrams: soft-ball (blue), hard-ball (red), helper (H), coach (C). */
const tokens = [{
  cls: 'bg-[#2C5FB8]',
  letter: ''
}, {
  cls: 'bg-cherry',
  letter: ''
}, {
  cls: 'bg-[#8A938C] text-white',
  letter: 'H'
}, {
  cls: 'bg-[#2C5FB8]',
  letter: ''
}, {
  cls: 'bg-willow text-willow-ink',
  letter: 'C'
}];
export function Hero() {
  return <section className="floodlit-outfield relative w-full overflow-hidden" data-id="element-155" data-mp="3d1a8hk3o4bda">
      <FieldLines className="absolute -right-56 top-[430px] h-[680px] w-[680px] sm:-right-24 sm:top-[360px] lg:-right-10 lg:top-[-60px] lg:h-[900px] lg:w-[900px]" data-id="element-156" data-mp="3cz5to748dry8" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-157" data-mp="3j9u0yz9q1olt">
        <div className="grid gap-7 lg:grid-cols-[1.12fr_.88fr] lg:items-center lg:gap-x-10 lg:gap-y-6" data-id="element-158" data-mp="3o73p8bldju82">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-159" data-mp="39a36gxl5v9lq">
            <p className="inline-flex items-center gap-2 rounded-full border border-cream/15 bg-cream/5 px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.2px] text-cream/80 sm:text-[11px] sm:tracking-[1.6px]" data-id="element-160" data-mp="3e8mur4n88xh9">
              <span className="h-2 w-2 flex-none rounded-full bg-cherry" aria-hidden="true" data-id="element-161" data-mp="359javyg8ke1p" />
              No-Queue Cricket · junior &amp; club coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-extrabold leading-[1.02] text-cream sm:text-[54px] lg:text-[54px] xl:text-[58px]" data-id="element-162" data-mp="2vieucuawwl4r">
              No more net queues.{' '}
              <br className="hidden sm:block" data-id="element-163" data-mp="2lkqwhvi0exid" />
              <span className="mark-stroke" data-id="element-164" data-mp="2ljh0dbupvzed">Every session already planned.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-165" data-mp="s3cla9fddhq1">
            <p className="max-w-xl text-[15px] leading-relaxed text-cream/80 sm:text-base lg:text-lg" data-id="element-166" data-mp="nb1kz5gpvtwy">
              90 ready-to-run sessions for junior and club cricket, built so every
              player has a bat, a ball or a job the whole session. Three stations,
              60, 75 or 90-minute versions and a wet-weather swap in every one.
              Print the page, set the cones, coach.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-167" data-mp="16346au4azydj">
              <CtaButton data-id="element-168" data-mp="112g55fmd215l">Get No-Queue Cricket</CtaButton>
            </div>
          </div>

          <div className="-mx-2 sm:mx-auto sm:w-full sm:max-w-[540px] lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:max-w-none lg:self-center" data-id="element-169" data-mp="x14ow0pdmsa2">
            <ProductVisual data-id="element-170" data-mp="3lu07neppzt62" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-171" data-mp="3lqm3c0xhx9vz">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-172" data-mp="3hqkbejhkbutw">
              <ul className="flex -space-x-2" aria-hidden="true" data-id="element-173" data-mp="1xacdyyq6tbr4">
                {tokens.map((t, i) => <li key={i} data-id="element-174" data-mp="21bpo3l0bc13u" data-mpi={i}>
                    <span className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-field-deep font-display text-sm font-extrabold shadow-[inset_0_-3px_6px_rgba(0,0,0,0.35)] sm:h-10 sm:w-10 ${t.cls}`} data-id="element-175" data-mp="218tq5wogtcfe">
                      {t.letter}
                    </span>
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-cream/70" data-id="element-176" data-mp="2kx2h63e9vcdb">
                Written for the <span className="font-semibold text-cream" data-id="element-177" data-mp="2p1a6o2sk0wcl">volunteer, parent &amp; club coaches</span>{' '}
                running junior cricket in the UK, Australia, New Zealand and South Africa.
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-cream/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-178" data-mp="zlkke0eooxyf">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-179" data-mp="4acnpgwqpx9j">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-willow" data-id="element-180" data-mp="3vhxgzllx9bzl" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-181" data-mp="e77jvt5jjlkn">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-182" data-mp="9bs7l5n6lxqc">
              {chips.map(chip => <li key={chip} className="rounded-full border border-cream/15 bg-field-deep/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-cream/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-183" data-mp="3hr25e1k1ggsb">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}